(() => {
  const fillInquiry = () => {
    const body = document.getElementById('ContactForm-body');
    if (!body || body.value.trim()) return;
    const params = new URLSearchParams(window.location.search);
    const id = params.get('contact[website_id]') || '';
    if (!/^(0|[1-9]\d{0,19})$/.test(id)) return;
    const product = (params.get('contact[product]') || `Offer ${id}`).trim().slice(0, 300);
    const lines = [`I'd like to ask about ${product}.`, `Offer ID: ${id}`];
    try {
      const url = new URL(params.get('contact[product_url]') || '', window.location.origin);
      if (url.origin === window.location.origin && url.pathname.startsWith('/products/')) {
        lines.push(`${url.origin}${url.pathname}`);
      }
    } catch { /* Product context still works without a valid URL. */ }
    body.value = `${lines.join('\n')}\n\n`;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillInquiry, { once: true });
  else fillInquiry();
})();
